export const a = [
  {
    d: 'M148,292 L148,304',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M128,288 L128,308',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M148,240 L128,260',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M128,308 L144,324',
    class: 'line diag-left',
    strokeLinecap: 'null',
  },
  {
    d: 'M144,272 L128,288',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M148,240 L224,240',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M144,272 L208,272',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M148,292 L188,292',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M148,304 L220,304',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M144,324 L224,324',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M129,260 L220,260',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M208,272 L188,292',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M220,260 L220,304',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M224,240 L240,256',
    class: 'line diag-left',
    strokeLinecap: 'null',
  },
  {
    d: 'M240,308 L224,324',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M240,256 L240,308',
    class: 'line vert',
    strokeLinecap: 'square',
  },
];

export const l = [
  {
    d: 'M376,240 L376,324',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M376,324 L396,324',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M376,240 L396,240',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M396,240 L396,324',
    class: 'line vert',
    strokeLinecap: 'square',
  },
];

export const e = [
  {
    d: 'M564,256 L564,308',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M564,308 L580,324',
    class: 'line diag-left',
    strokeLinecap: 'null',
  },
  {
    d: 'M580,240 L564,256',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M584,260 L584,304',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M616,272 L596,292',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M580,240 L660,240',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M584,260 L656,260',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M580,324 L656,324',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M596,292 L660,292',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M616,272 L656,272',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M656,260 L656,272',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M660,240 L676,256',
    class: 'line diag-left',
    strokeLinecap: 'null',
  },
  {
    d: 'M676,304 L656,324',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M676,276 L660,292',
    class: 'line diag-right',
    strokeLinecap: 'null',
  },
  {
    d: 'M584,304 L676,304',
    class: 'line hori',
    strokeLinecap: 'square',
  },
  {
    d: 'M676,256 L676,276',
    class: 'line vert',
    strokeLinecap: 'square',
  },
];

export const x = [
  {
    d: 'M 0,0 L 20,0',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M 0,84 L 20,84',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M 102,0 L 122,0',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M 102,84 L 122,84',
    class: 'line vert',
    strokeLinecap: 'square',
  },
  {
    d: 'M 20,0 L 61,32',
    class: 'line diag-left',
    strokeLinecap: 'square',
  },
  {
    d: 'M 102,0 L 61,32',
    class: 'line diag-right',
    strokeLinecap: 'square',
  },
  {
    d: 'M 20,84 L 61,52',
    class: 'line diag-left',
    strokeLinecap: 'square',
  },
  {
    d: 'M 102,84 L 61,52',
    class: 'line diag-right',
    strokeLinecap: 'square',
  },
  {
    d: 'M 0,0 L 51,42',
    class: 'line diag-left',
    strokeLinecap: 'square',
  },
  {
    d: 'M 0,84 L 51,42',
    class: 'line diag-left',
    strokeLinecap: 'square',
  },

  {
    d: 'M 122,0 L 71,42',
    class: 'line diag-right',
    strokeLinecap: 'square',
  },
  {
    d: 'M 122,84 L 71,42',
    class: 'line diag-right',
    strokeLinecap: 'square',
  },
];
